$(document).ready(function() {
   $('.gradient .shop-preloader').fadeOut(300);


    $('.burger').click(function(){
        $('body').addClass('hidden-cust');
        $('.mobile-menu').fadeIn(300);
    });

    $('.burger-min').click(function(){
         $('body').removeClass('hidden-cust');
        $('.mobile-menu').fadeOut(300);
    });

    $('.footer-title').each(function(i, item){
        $(item).click(function(e){
            e.preventDefault();
            $(this).toggleClass('active');
            $($('.footer__links')[i]).slideToggle(300);
        });
    });
    
    $('.the-best-product-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        customPaging: function(slick,index) {
            return '<a class="dot"></a>';
        },
        responsive: [
            {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
            }
            },
        ]
    });

     $('.roots-product-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        customPaging: function(slick,index) {
            return '<a class="dot"></a>';
        },
        responsive: [
            {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
            }
            },
            {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
            }
            },
        ]
    });
    
 if ($(window).width() <= 767) {
     $('.relative-products-inner').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        customPaging: function(slick,index) {
            return '<a class="dot"></a>';
        },
    });
 }

    $('.faq-section').each(function(i, item){
        $(item).attr('id', 'faq-' + i);
        $("#faq-"+ i + " .faq-question").each(function(k, quest){
            $(quest).click(function(){
                $($("#faq-"+ i + " .faq-item")[k]).toggleClass('active');
                $($("#faq-"+ i + " .faq-answer")[k]).slideToggle(300);
            });
        });
    });

    $('.our-values-inner').each(function(i, item){
        $(item).attr('id', 'our-values-inner-' + i);
        $("#our-values-inner-"+ i + " .our-values-col-title").each(function(k, quest){
            $(quest).click(function(){
                $($("#our-values-inner-"+ i + " .our-values-col-title")[k]).toggleClass('active');
                $($("#our-values-inner-"+ i + " .our-values-col-text")[k]).slideToggle(300);
            });
        });
    });

    $('.roots-map-dot').each(function(i, item){
        $(item).click(function(){
            if(!$(item).hasClass('active')) {
                $('.roots-map-dot.active').removeClass('active');
                $(item).addClass('active');

                if ($(window).width() >= 768) {
                    $('.roots-map-content-item.active').fadeOut(300);
                    $('.roots-map-content-item.active').removeClass('active');

                    $($('.roots-map-content-item')[i]).fadeIn(300);
                    $($('.roots-map-content-item')[i]).addClass('active');
                }


               $('.roots-map-dishes-list.active').fadeOut(300);
                $('.roots-map-dishes-list.active').removeClass('active');

                $($('.roots-map-dishes-list')[i]).fadeIn(300);
                $($('.roots-map-dishes-list')[i]).addClass('active');

            }
        });
    })

    if ($(window).width() >= 768) {
        $('.roots-map-content-item').each(function(i, item){
            $(item).click(function(){
                if(!$($('.roots-map-dot')[i]).hasClass('active')) {
                    $('.roots-map-dot.active').removeClass('active');
                    $($('.roots-map-dot')[i]).addClass('active');


                    $('.roots-map-dishes-list.active').fadeOut(300);
                    $('.roots-map-dishes-list.active').removeClass('active');

                    $($('.roots-map-dishes-list')[i]).fadeIn(300);
                    $($('.roots-map-dishes-list')[i]).addClass('active');

                }
            });
        })
    }


});

$(document).ready(function() {
    const $dots = $('.roots-map-dot');
    const $dishesLists = $('.roots-map-dishes-list');
    const $slider = $('.roots-map-content');

    // Функція для зміни страв (десктоп + мобілка)
    function switchDishes(index) {
        const $currentActive = $dishesLists.filter('.active');
        const $nextActive = $dishesLists.eq(index);

        if (!$nextActive.hasClass('active')) {
            $currentActive.fadeOut(300, function() {
                $(this).removeClass('active');
                $nextActive.fadeIn(300).addClass('active');
            });
        }
    }

    
    if ($(window).width() <= 767) {
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            customPaging: function(slick, index) {
                return '<a class="dot"></a>';
            }
        });

       
        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $dots.removeClass('active').eq(nextSlide).addClass('active');
            switchDishes(nextSlide);
        });
    }

    
    $dots.on('click', function() {
        const index = $dots.index(this);

        if ($(window).width() <= 767 && $slider.hasClass('slick-initialized')) {
            $slider.slick('slickGoTo', index);
        } else {
            
            $dots.removeClass('active');
            $(this).addClass('active');
            switchDishes(index);
        }
    });
});





gsap.registerPlugin(ScrollTrigger);


const items = document.querySelectorAll('.features-prod-item');

 if ($(window).width() >= 576) {
    if (items.length > 0) {
        gsap.fromTo(items, 
            {
            
            xPercent: -70,
            opacity: 0
            },
            {
            
            xPercent: 0,
            opacity: 1,
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.2, 
            scrollTrigger: {
                trigger: ".features",
                start: "top 80%", 
                toggleActions: "play none none none",
            
            }
            }
        );
    }
 }
document.addEventListener('DOMContentLoaded', function() {
  if (typeof gsap !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    if ($(window).width() >= 576) {
        // Створюємо масив елементів для послідовної появи
        const textElements = [
        ".featuires-title", 
        ".features-text", 
        ".features-inner .btn-wrap"
        ];

        gsap.from(textElements, {

        y: 50,
        opacity: 0,
        
        duration: 0.8, 
        ease: "power2.out", 
        stagger: 0.2, 
        
        scrollTrigger: {
            trigger: ".features", 
            start: "top 80%",    
            toggleActions: "play none none none" 
            
        }
        });

        const sliderProd = [
        ".the-best-product-title", 
        ".the-best-product-slider", 
        ".the-best-product-title .btn-wrap"
        ];

        gsap.from(sliderProd, {

        y: 50,
        opacity: 0,
        
        duration: 0.8, 
        ease: "power2.out", 
        stagger: 0.2, 
        
        scrollTrigger: {
            trigger: ".the-best-product", 
            start: "top 80%",    
            toggleActions: "play none none none" 
            
        }
        });


        }
    }

    $('.prod-tab').each(function(i, item){
        $(item).click(function(){
            if(!$(item).hasClass('active')) {

                $('.prod-tab.active').removeClass('active');
                $(item).addClass('active');

                $('.prod-tab-mobile.active').removeClass('active');
                $($('.prod-tab-mobile')[i]).addClass('active');

                $('.prod-tabs-content').hide();
                $($('.prod-tabs-content')[i]).show();
            }
        });
    });


     $('.prod-tab-mobile').each(function(i, item){
        $(item).click(function(){
            if(!$(item).hasClass('active')) {

                $('.prod-tab.active').removeClass('active');
                $(item).addClass('active');

                $('.prod-tab-mobile.active').removeClass('active');
                $($('.prod-tab-mobile')[i]).addClass('active');

                $('.prod-tabs-content').hide();
                $($('.prod-tabs-content')[i]).slideDown(300);
            }
        });
    });

    $('.no-register').click(function(e){
        e.preventDefault();
        $('.auth-popup').fadeIn(300);
    });

    $('.auth-popup').click(function(e){
        let target = e.target;
        if(target.closest('.auth-popup-win') == null){
           $('.auth-popup').fadeOut(300); 
        }
    });
    $('.custom-toggle-container .button').click(function(){
        $(this).toggleClass('active');
    });

    if( $('.collection-nav-options').length > 0){

        $('.collection-nav-select').click(function(){
            $('.collection-nav-options').toggleClass('active');
        }) 
    }

    if( $('.custom-select-placeholder').length > 0){

        $('.custom-select-placeholder ').click(function(){
            $('.custom-sort-select').toggleClass('active');
        }) 
    }

    $('.custom-options li').click(function(){
         $('.custom-sort-select').removeClass('active');
         let text = $(this).text();
         $('.custom-select-placeholder .curr-val').text(text);
    })
    
    $('body').click(function(e){
           let target = e.target;

            if(target.closest('.collections-nav-list') == null){
                 $('.collection-nav-options').removeClass('active');
            }

             if(target.closest('.custom-sort-select') == null){
                 $('.custom-sort-select').removeClass('active');
            }

        });

    $('.login-btn').click(function(e){
        e.preventDefault();
        $('.auth-popup').fadeIn(300);
    });

    $('.single-prod-big-img-inner').slick({
         slidesToShow: 1,       
        slidesToScroll: 1,
        arrows: false,          
        fade: true,            
        infinite: true,
        centerMode: false
    });

    const $thumbnails = $('.single-prod-small-img-container');
    const $slider = $('.single-prod-big-img-inner'); 

  
    $thumbnails.on('click', function() {
        const index = $(this).index();
        $slider.slick('slickGoTo', index);
    });

    $slider.on('afterChange', function(event, slick, currentSlide) {
        $thumbnails.removeClass('active');
        $thumbnails.eq(currentSlide).addClass('active');
    });

});


document.addEventListener('DOMContentLoaded', () => {
  const searchModal = document.querySelector('details-modal');

  if (searchModal) {
    searchModal.addEventListener('click', (event) => {
      
      const isOutsideContent = !event.target.closest('.search-modal__content');
      
     
      const isNotHeaderIcon = !event.target.closest('.header__icon');

     
      if (isOutsideContent && isNotHeaderIcon) {
        searchModal.close();
      }
    });
  }
});


document.addEventListener('click', function(e) {
 
  const customOption = e.target.closest('.custom-options li');
  
  if (customOption) {
    const valueToSelect = customOption.getAttribute('data-value'); 
    const realSelect = document.getElementById('SortBy'); 

    if (realSelect) {
      
      realSelect.value = valueToSelect;
      
      
      realSelect.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
});

document.addEventListener('click', function(event) {
  
  if (event.target.closest('.rewards-btn')) {
    event.preventDefault();

    // 1. Намагаємось викликати метод через SDK, якщо він вже готовий
    if (window.SmileUI && window.SmileUI.openPanel) {
      window.SmileUI.openPanel();
    } else {
      
      const smileLauncher = document.querySelector('.smile-launcher-button') || 
                            document.querySelector('#smile-ui-container iframe');
      
      if (smileLauncher) {
        smileLauncher.click();
      } else {
        // 3. Резервний варіант: відкриття через зміну hash в URL
        window.location.hash = 'smile-home';
      }
    }
  }
});

document.addEventListener('submit', function(event) {
  
  const isSearchForm = event.target.action && event.target.action.includes('/search');
  
  if (isSearchForm) {
    event.preventDefault(); 
    return false;
  }
});


document.addEventListener('keydown', function(event) {
  if (event.key === 'Enter' && event.target.getAttribute('name') === 'q') {
    event.preventDefault();
    return false;
  }
});


/*
gsap.registerPlugin(ScrollTrigger);

function getDist() {
  return window.innerWidth <= 575 ? 175 : 295;
}


const commonScrollSettings = {
  trigger: ".home-the-best-section",
  start: "top bottom",
  end: "top bottom-=800",
  scrub: 1.1,
  invalidateOnRefresh: true, 
};

gsap.to(".home-the-best-title", {
  y: () => getDist(),
  ease: "power1.out",
  scrollTrigger: commonScrollSettings
});

gsap.to(".homepage-hero-title", {
  y: () => getDist(),
  ease: "power1.out",
  scrollTrigger: commonScrollSettings
});


if(window.innerWidth > 991) {
    const commonScrollSettings = {
    trigger: ".home-the-best-section",
    start: "top bottom",
    end: "top bottom-=800",
    scrub: 1.1,
    invalidateOnRefresh: true, 
    };

    gsap.to(".home-the-best-title", {
    y: () => getDist(),
    ease: "power1.out",
    scrollTrigger: commonScrollSettings
    });

    gsap.to(".homepage-hero-title", {
    y: () => getDist(),
    ease: "power1.out",
    scrollTrigger: commonScrollSettings
    });
} 
    */